module.exports = __webpack_public_path__ + "static/media/back-arrow.44601726.svg";